import { useCallback } from "react";
import {
  trackEvent,
  identifyUser,
  setUserProperty as setAmplitudeUserProperty,
  resetAmplitude,
  EventProperties,
} from "../services/analytics/amplitude";
import { ANALYTICS_EVENTS } from "../services/analytics/events";

/**
 * Hook to use Amplitude analytics in React components
 */
export const useAmplitude = () => {
  const track = useCallback((eventName: string, properties?: EventProperties) => {
    trackEvent(eventName, properties);
  }, []);

  const trackButtonClick = useCallback((buttonName: string, properties?: EventProperties) => {
    trackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_name: buttonName,
      ...properties,
    });
  }, []);

  const identify = useCallback((userId: string, userProperties?: Record<string, any>) => {
    identifyUser(userId, userProperties);
  }, []);

  const setUserProperty = useCallback((key: string, value: any) => {
    setAmplitudeUserProperty(key, value);
  }, []);

  const reset = useCallback(() => {
    resetAmplitude();
  }, []);

  return {
    track,
    trackButtonClick,
    identify,
    setUserProperty,
    reset,
  };
};
